import type { CanvasJSON } from '../../canvas/types';

/**
 * Collects every image `src` referenced by a CanvasJSON.
 * Skips data URLs (no network round-trip to warm up).
 */
export function extractImageUrls(json: CanvasJSON): string[] {
  const urls: string[] = [];
  for (const obj of json.objects) {
    const src = (obj as { src?: unknown }).src;
    if (typeof src !== 'string' || !src || src.startsWith('data:')) continue;
    urls.push(src);
  }
  return urls;
}
